export default {
  // Zbývající čas (aktivní hlasování) – počítací pád po „Zbývá"
  remainsDays_zero: 'Zbývá poslední den',
  remainsDays_one: 'Zbývá {{count}} den',
  remainsDays_few: 'Zbývají {{count}} dny',
  remainsDays_other: 'Zbývá {{count}} dní',
  remainsMonths_one: 'Zbývá {{count}} měsíc',
  remainsMonths_few: 'Zbývají {{count}} měsíce',
  remainsMonths_other: 'Zbývá {{count}} měsíců',
  remainsYears_one: 'Zbývá {{count}} rok',
  remainsYears_few: 'Zbývají {{count}} roky',
  remainsYears_other: 'Zbývá {{count}} let',

  // Doba od ukončení – instrumentál po „před" (plurál je vždy „dny / měsíci / lety")
  expiredDays_one: 'Ukončeno před {{count}} dnem',
  expiredDays_few: 'Ukončeno před {{count}} dny',
  expiredDays_other: 'Ukončeno před {{count}} dny',
  expiredMonths_one: 'Ukončeno před {{count}} měsícem',
  expiredMonths_few: 'Ukončeno před {{count}} měsíci',
  expiredMonths_other: 'Ukončeno před {{count}} měsíci',
  expiredYears_one: 'Ukončeno před {{count}} rokem',
  expiredYears_few: 'Ukončeno před {{count}} lety',
  expiredYears_other: 'Ukončeno před {{count}} lety',

  waitSeconds_zero: 'sekund',
  waitSeconds_one: 'sekundu',
  waitSeconds_few: 'sekundy',
  waitSeconds_other: 'sekund',
};
